import { render, staticRenderFns } from "./ParticipantEvent.vue?vue&type=template&id=48dd5484&"
import script from "./ParticipantEvent.vue?vue&type=script&lang=js&"
export * from "./ParticipantEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports